const REFRESH_TOKEN = "app.refreshToken";
const listeners = new Set();

function notify() {
    for (const listener of listeners) {
        try {
            listener();
        } catch {
            // ignore listener errors
        }
    }
}


export function getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN);
}

export function getToken() {
    return getRefreshToken();
}

export function subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function setRefreshToken(token) {
    if (token) {
        localStorage.setItem(REFRESH_TOKEN, token);
    } else {
        localStorage.removeItem(REFRESH_TOKEN);
    }
    notify();
}

export function clearToken() {
    setRefreshToken(null);
}

